import type { SVGProps } from 'react'
const SvgSyTether = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" width={24} height={24} {...props}>
		<path d="M595.7 532.6c-5.3.4-33 2.1-94.6 2.1-49 0-83.8-1.5-96-2.1-189.4-8.3-330.9-41.3-330.9-80.8s141.4-72.4 330.9-80.9v128.8c12.4.9 47.9 3 96.9 3 58.8 0 88.3-2.5 93.6-2.9V371c189 8.4 330.1 41.4 330.1 80.8s-141 72.4-330.1 80.8zm0-175V242.3h263.8V66.5H141.3v175.8h263.8v115.2c-214.4 9.8-375.6 52.3-375.6 103.2S190.6 554.1 405.1 564v369.4h190.7V563.9c213.9-9.8 374.9-52.3 374.9-103.1s-160.9-93.3-375-103.2m0 0" />
	</svg>
)
export default SvgSyTether
